// @flow
import React, { useState, useEffect, Fragment } from "react";
import Routes from "./Routes";
import "react-spring-bottom-sheet/dist/style.css";

function App() {
  return (
    <main>
      <Routes />
    </main>
  );
}

export default App;
